import './RegNoInput.scss';
import '../Shared/common.scss';
import { InputLabel, OutlinedInput } from "@mui/material";
import { Control, Controller } from "react-hook-form";

const RegNoInput = ({
    control,
    label,
    name = "regno",
    size = "small",
}: any & {
    control?: Control<any>;
    label?: string;
    name?: string;
    size?: string;
}) => {

    return (
        <>
            <Controller
                name={name}
                control={control}
                render={({
                    field: { onChange, value },
                    fieldState: { error },
                    formState,
                }) => (
                    <>
                        <InputLabel htmlFor="regNo">{label}</InputLabel>
                        <OutlinedInput
                            id="regNo"
                            key="regNo"
                            name={name}
                            label={label}
                            value={value}
                            onChange={onChange}
                            className='regNo'
                            inputProps={{
                                min: 0, maxLength: 8, style: { 
                                    textAlign: 'center', 
                                    textTransform: 'uppercase', 
                                    fontWeight: 'bold', 
                                    fontSize: '150%', 
                                    // color: 'black',
                                    letterSpacing: '0.05em' }
                            }}
                            size={size}
                        />
                    </>

                )}
            />
        </>
    );
};

export default RegNoInput;
